export default {
  getAccountDetailCount: state => state.cnt,
  getGridDataAccountDetail: state => state.gridData,
  getSearchParamAccountDetail: state => state.searchParam,
};



// WEBPACK FOOTER //
// ./src/vuex/monitoring/cloudaccount/detail/accountDetailGetter.js